var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React from 'react';
import t from 'prop-types';
import Boton from './boton';
import * as HERRAMIENTA from './constantes';

function BotonMuestraColor(props) {
  var valor = props.valor;
  var clases = ['botonColor'];
  var style = {
    backgroundColor: valor
  };
  return React.createElement(Boton, _extends({}, props, {
    style: style,
    extraClases: clases
  }));
}

BotonMuestraColor.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Identificador del boton */
  herramientaId: t.string.isRequired,

  /** Grupo de la barra de herramientas al que pertenece el boton */
  grupo: t.string.isRequired,

  /** color */
  valor: t.string.isRequired,

  /** (id, grupo, valor) => {...} */
  onPresionado: t.func.isRequired
} : {};
BotonMuestraColor.defaultProps = {
  herramientaId: HERRAMIENTA.LAPIZ_COLOR_ID,
  grupo: HERRAMIENTA.GRUPO_PIZARRA
};
export default BotonMuestraColor;